<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">工资发放明细表</li>
    </ul>
    <ul class="c-list-search">
      <c_statusradiogroup
        v-model="state.params.type"
        arrName="salaryrecordemployee_type"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="姓名、证件号、发薪单号"
        clearable
        @clear="
          delete state.params.name;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.alias + '(' + item.name + ')'"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <c_withholdingagentselectgroup
        @confirm="
          (item) => {
            state.params.withholding_agent_type = item.type;
            state.params.withholding_agent_id = item.ids;
          }
        "
      ></c_withholdingagentselectgroup>
      <el-date-picker
        v-model="state.params.month"
        type="month"
        format="YYYY年M月"
        value-format="YYYY-MM"
        placeholder="薪资所属期"
        style="width: 200px"
      />
      <li style="width: 300px">
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="发放日期"
          end-placeholder="发放日期"
          value-format="YYYY-MM-DD"
          style="width: 100%"
          @change="
            (value) => {
              if (value) state.params.pay_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.pay_date;
          "
        />
      </li>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="name"
          sortable="name"
          label="姓名"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
          width="120"
          fixed="left"
        />
        <el-table-column prop="phone" label="手机号" width="140">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="手机号"
              @click="$onCopy(row.phone)"
            >
              {{ row.phone }}
            </text>
          </template>
        </el-table-column>
        <el-table-column prop="idcard" label="证件号" width="180">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(row.idcard)"
            >
              {{ row.idcard }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="发放方式"
          :formatter="$tab_TextFormat"
          :width="120"
        >
          <template #default="{ row }">
            <c_status arrName="salaryrecord_type" :value="row.type" />
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120">
          <template #default="{ row }">
            <c_status
              arrName="payrollemployee_pay_status"
              :value="row.pay_status"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="bank_account"
          label="收款账号"
          :formatter="$tab_TextFormat"
          :width="160"
        />
        <el-table-column
          prop="payroll_order_id"
          label="发薪单号"
          :formatter="$tab_TextFormat"
          :min-width="140"
        />
        <el-table-column
          prop="customer_name"
          label="所属客户"
          :formatter="$tab_TextFormat"
          :min-width="200"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :min-width="200"
          :formatter="$tab_TextFormat"
        >
          <template #default="{ row }">
            <div
              v-if="row.withholding_agent_name"
              :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
              :style="{
                '--dynamic-color':
                  row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
              }"
              class="withholding-badge"
            >
              {{ row.withholding_agent_name }}
            </div>
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="month"
          label="薪资所属期"
          :formatter="$tab_TextFormat"
          align="center"
          :width="120"
        />
        <el-table-column
          prop="money"
          label="发放金额"
          :formatter="$tab_MoneyFormat"
          align="center"
          :min-width="160"
        />
        <el-table-column
          prop="pay_date"
          label="发放时间"
          :formatter="$tab_TextFormat"
          align="center"
          :width="120"
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { data_customer_select } from "@/http/data";
import { salaryrecordemployee_list } from "@/http/salaryrecordemployee";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadCustomer();
      onLoad();
    });

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    const onLoad = () => {
      delete state.tableData;

      salaryrecordemployee_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
